<div #root class="root-container">

  <div class="body">
    
    <div [ngClass]="{'collapsed': this.positionsSectionCollapsed}" class="column positions">
      
      <ets-hg-section-header
        (toggleCollapsed)="this.toggleSectionCollapsed('positions')"
        [collapsed]="this.positionsSectionCollapsed"
        [text]="'Portfolios'"
      ></ets-hg-section-header>
      
      <div [class.ets-hidden]="this.positionsSectionCollapsed" class="column-body">
        <ets-hg-positions-section
          (portfolioSelected)="this.onPortfolioSelected($event)">
        </ets-hg-positions-section>
      </div>
    
    </div>
    
    <div [ngClass]="{'collapsed': this.settingsSectionCollapsed}" class="column settings">
      
      <ets-hg-section-header
        (toggleCollapsed)="this.toggleSectionCollapsed('settings')"
        (expandHedgePadRequest)="this.onExpandHedgePadRequest()"
        [collapsed]="this.settingsSectionCollapsed"
        [text]="'Hedge Pad'"
        [underlying]="this.underlyingDisplayName"
        [showHedgePadIcons]="this.showHedgePadIconsInHeader"
      ></ets-hg-section-header>
      
      <div [class.ets-hidden]="this.settingsSectionCollapsed" class="column-body">
        <ets-hg-settings-section
          #settingsSection
          (reviewChangesClicked)="this.onReviewChangesClicked()"
          [portfolioDefaultQty]="this.portfolioDefaultQty"
        ></ets-hg-settings-section>
      </div>
    
    </div>
    
    <ng-container *ngIf="this.isHedgingMatrixAvailable()">
      <div #matrixColumn [ngClass]="{'collapsed': this.matrixSectionCollapsed}" class="column settings copilot-host">

        <ets-hg-section-header
          (toggleCollapsed)="this.toggleSectionCollapsed('matrix')"
          [collapsed]="this.matrixSectionCollapsed"
          [text]="'Hedge Matrix'"
          [underlying]="this.underlyingDisplayName"
        ></ets-hg-section-header>

        <div [class.ets-hidden]="this.matrixSectionCollapsed" class="column-body">
          <ets-hg-hedge-matrix
            (acquireRequested)="this.onAcquireRequested($event)"
          ></ets-hg-hedge-matrix>
        </div>

        <!-- CoPilot floating launcher (CR-20260619-001): child of the Hedge Matrix — only shown when the
             matrix is available + expanded and the CoPilot popup is closed. Hidden while the popup is open.
             DRAGGABLE within the matrix column via etsDraggable (A7/WI-11); default rests at the matrix
             bottom-right (unchanged). copilotFabPosition is session-only and survives the *ngIf teardown. -->
        <button
          *ngIf="this.isCoPilotAvailable() && !this.matrixSectionCollapsed && !this.copilotPopupVisible && this.selectedPortfolio"
          type="button"
          class="copilot-fab"
          [class.es-mode]="this.orionEsMode"
          [class.has-suggestions]="adjustmentAvailability.count > 0"
          [attr.aria-label]="adjustmentAvailability.count > 0 ? 'ORION Adjustments Available: ' + adjustmentAvailability.count : 'ORION'"
          [class.is-stale]="this.copilotIsStale && adjustmentAvailability.count === 0"
          etsDraggable
          [etsDraggablePosition]="this.copilotFabPosition"
          (etsDraggablePositionChange)="this.copilotFabPosition = $event"
          (click)="this.openCopilot()"
        >
          <i class="fas fa-brain"></i>
          <span>ORION</span>
          <span class="suggestion-count" *ngIf="adjustmentAvailability.count > 0">{{ adjustmentAvailability.count }}</span>
        </button>

      </div>
    </ng-container>
    
    <div [ngClass]="{'collapsed': this.strategiesSectionCollapsed}" class="column strategies">
      
      <ets-hg-section-header
        (toggleCollapsed)="this.toggleSectionCollapsed('strategies')"
        [collapsed]="this.strategiesSectionCollapsed"
        [text]="'Strategies'"
        [underlying]="this.underlyingDisplayName"
      ></ets-hg-section-header>
      
      <div [class.ets-hidden]="this.strategiesSectionCollapsed" class="column-body">
        <ets-hg-strategies-section [portfolioDefaultQty]="this.portfolioDefaultQty">
        </ets-hg-strategies-section>
      </div>
    </div>
    
    <div [ngClass]="{'collapsed': this.priceboxSectionCollapsed}" class="column pricebox">
      
      <ets-hg-section-header
        (toggleCollapsed)="this.toggleSectionCollapsed('pricebox')"
        [collapsed]="this.priceboxSectionCollapsed"
        [text]="'Pricebox'"
        [underlying]="this.underlyingDisplayName"
      ></ets-hg-section-header>
      
      <div [class.ets-hidden]="this.priceboxSectionCollapsed" class="column-body">
        <ets-hg-pricebox-section [portfolioDefaultQty]="this.portfolioDefaultQty">
        </ets-hg-pricebox-section>
      </div>
    
    </div>
    
    <div [ngClass]="{'collapsed': this.zonesGridSectionCollapsed}" class="column zones-grid">
      
      <ets-hg-section-header
        (toggleCollapsed)="this.toggleSectionCollapsed('zones-grd')"
        (linkStateChanged)="this.onZonesGridLinkStateChanged($event)"
        (clearDataRequest)="this.onZonesGridClearDataRequest()"
        (loadDataRequest)="this.onZonesGridLoadDataClicked()"
        [showZonesGridIcons]="true"
        [collapsed]="this.zonesGridSectionCollapsed"
        [text]="'Zones Grid'"
        [underlying]="this.underlyingDisplayName"
        [ctx]="this"
      ></ets-hg-section-header>
      
      <div [class.ets-hidden]="this.zonesGridSectionCollapsed" class="zones-grid-body">
        <ets-hg-zones-grid-section>
        </ets-hg-zones-grid-section>
      </div>
    </div>
  
  </div>

  <hg-testing-component></hg-testing-component>

</div>

<dx-load-panel
  [position]="{my: 'center', at:'center', of: root}"
  [visible]="this.isLoading"
></dx-load-panel>

<!-- CoPilot floating window (CR-20260619-001): a non-blocking (unshaded), draggable dx-popup that hosts the
     UNCHANGED CoPilot child. Gated by the same entitlement as the launcher + the Hedge Matrix (CoPilot is a
     child of the matrix). The child stays mounted while the popup is hidden, so an in-flight run + previewed
     legs survive close/reopen; only portfolio-switch / new-conversation / reload tear them down (unchanged).
     [ctx]="settingsSection" reuses the always-in-DOM Hedge Pad facade ref (the grid-manipulation seam).
     [deferRendering]="false" forces the child to render at host init instead of on first open (dx-popup
     defers content by default). The child's Hg.HedgeMatrixChanged subscription must be live COLD so the
     collapsed-launcher drift cue appears when the matrix is edited before CoPilot is ever opened — the
     primary scenario for that cue. Eager render while hidden is safe (the child's height measure no-ops
     on offsetHeight<=0). -->
<dx-popup
  #copilotPopupRef
  *ngIf="this.isCoPilotAvailable() && this.isHedgingMatrixAvailable()"
  [deferRendering]="false"
  [(visible)]="this.copilotPopupVisible"
  [position]="this.copilotPopupPosition"
  [shading]="false"
  [dragEnabled]="true"
  [resizeEnabled]="true"
  [closeOnOutsideClick]="false"
  [showTitle]="true"
  titleTemplate="title"
  title="ORION (Hedging Grid)"
  [width]="this.copilotPopupWidth"
  [height]="this.copilotPopupHeight"
  [minWidth]="320"
  [minHeight]="240"
  [wrapperAttr]="{class: 'orion-copilot-popup'}"
  (onShown)="this.onCopilotPopupShown()"
  (onHidden)="this.onCopilotPopupHidden()"
>
  <!-- CR-20260924-002: the title bar carries the ES toggle — the Hedge Matrix Columns dialog's own
       shape (title, switch beside it, close icon on the right). A custom title template drops the
       built-in close button, so the icon here closes the window (a minimize: nothing is torn down).
       The switch shows only for an ES-eligible (SPX-family) portfolio. -->
  <!-- Markup and styles mirror hg-hedge-matrix-hedges-selector's title template one to one (owner
       smoke round 2, 2026-09-24: "styled just like the Hedge Matrix column selector"). -->
  <div *dxTemplate="let data of 'title'" class="orion-title-bar" [class.es-mode]="this.orionEsMode">
    <div class="window-title">
      <div class="title-with-toggle">
        <span>ORION (Hedging Grid)</span>
        <span class="es-hedging-toggle" *ngIf="this.isOrionEsEligible" title="Answers come back on the ES contract; inputs stay SPX">
          <span class="label">ES</span>
          <dx-switch [value]="this.orionEsMode" (onValueChanged)="this.onOrionEsModeChanged($event)"></dx-switch>
        </span>
      </div>
      <div class="icons">
        <span class="close icon">
          <i class="fas fa-times fa-lg" (click)="this.closeCopilotPopup()"></i>
        </span>
      </div>
    </div>
  </div>
  <div *dxTemplate="let data of 'content'" class="copilot-popup-body">
    <ets-hg-copilot
      [adjustmentAvailability]="adjustmentAvailability"
      [portfolioId]="this.selectedPortfolio?.id"
      [portfolioOwnerId]="this.selectedPortfolio?.userId"
      [availableTargetItemId]="this.availableAdjustmentTarget"
      [availableTargetRequest]="this.availableAdjustmentNavigation"
      [popupVisible]="this.copilotPopupVisible"
      [ctx]="this"
      (contentHeightChange)="this.onCopilotContentHeight($event)"
      (widthModeChange)="this.onCopilotWidthMode($event)"
      (previewActiveChange)="this.onCopilotPreviewActiveChange($event)"
      (staleChange)="this.onCopilotStaleChange($event)"
    ></ets-hg-copilot>
    <!-- Window zoom sidebar (CR-20260830-001, owner round 3: the ONLY zoom control — the in-title
         variant is gone, "no matter what, it always gets shrinked along with the header"). Always
         visible on the window's right edge, top-aligned with the window's top edge. Authored inside
         the content template (so Angular owns the bindings) but RELOCATED onto .dx-overlay-content
         on popup shown (applyCopilotZoom) — that makes the overlay the containing block, so
         `left: 100%` hangs it off the window's right edge as a floating tab, clear of the
         popup-content padding and scroll. Counter-scaled (1/level) so it renders at natural size
         while the window shrinks. Layout per owner sketch: plus on top, rotated percent, minus at
         the bottom. The strip is ALSO the window's "ear" drag handle (owner round 3: the shrunken
         title is hard to grab) — pointerdown anywhere except the +/- buttons drags the window. -->
    <!-- dblclick reset lives on the STRIP, not the .pct child: the drag handler pointer-captures
         to the strip, and after a capture the browser retargets the compat click/dblclick there —
         a child-level dblclick binding never fires. The handler excludes the +/- buttons. -->
    <div class="orion-zoom-strip"
         [style.transform]="'scale(' + (1 / this.copilotZoomLevel) + ')'"
         (pointerdown)="this.onCopilotZoomStripPointerDown($event)"
         (dblclick)="this.onCopilotZoomStripDblClick($event)">
      <div class="btn" (click)="this.copilotZoomIn()">+</div>
      <div class="pct" title="Double-click to reset to 100%">{{this.copilotZoomPct}}%</div>
      <div class="btn" (click)="this.copilotZoomOut()">-</div>
    </div>
  </div>
</dx-popup>
